import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue";
import { ref, watch } from 'vue';
import VoucherCard from './elements/VoucherCard.vue';
import PaginationDots from './elements/PaginationDots.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'VoucherCarousel',
    props: {
        items: {},
        formatter: {},
        visibleDots: {},
        defaultVoucherId: {}
    },
    emits: ["voucherSelected"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const currentDot = ref(0);
        watch(() => props.items, (newItems) => {
            if (props.defaultVoucherId) {
                const idx = newItems.findIndex((v) => v.id == props.defaultVoucherId);
                if (idx !== -1) {
                    currentDot.value = idx;
                }
            }
        }, { immediate: true });
        watch(currentDot, (newIndex) => {
            emit('voucherSelected', newIndex);
        });
        return (_ctx, _cache) => {
            const _component_v_carousel_item = _resolveComponent("v-carousel-item");
            const _component_v_carousel = _resolveComponent("v-carousel");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(_component_v_carousel, {
                    modelValue: currentDot.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((currentDot).value = $event)),
                    "show-arrows": false,
                    "show-arrows-on-hover": false,
                    "hide-delimiter-background": "",
                    "hide-delimiters": "",
                    "delimiter-icon": "mdi-circle",
                    continuous: false,
                    class: "voucherGroup"
                }, {
                    default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
                            return (_openBlock(), _createBlock(_component_v_carousel_item, { key: index }, {
                                default: _withCtx(() => [
                                    _createVNode(VoucherCard, {
                                        voucher: item,
                                        formatter: _ctx.formatter
                                    }, null, 8, ["voucher", "formatter"])
                                ]),
                                _: 2
                            }, 1024));
                        }), 128))
                    ]),
                    _: 1
                }, 8, ["modelValue"]),
                _createVNode(PaginationDots, {
                    class: "mb-2",
                    "total-items": _ctx.items.length,
                    "current-index": currentDot.value,
                    maxDots: _ctx.visibleDots
                }, null, 8, ["total-items", "current-index", "maxDots"])
            ], 64));
        };
    }
});
